import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface VersionSelectProps {
    currentVersion: string;
    versions: string[];
    onVersionChange: (v: string) => void;
}

export default function PackageVersionSelector(props: VersionSelectProps) {
    const [version, setVersion] = React.useState(props.currentVersion);

    const handleChange = (event: SelectChangeEvent) => {
        const newVersion = event.target.value as string;
        setVersion(newVersion);
        props.onVersionChange(newVersion);
    };

    return (
        <Box sx={{ width: 120 }}>
            <FormControl variant="standard">
                <InputLabel id="demo-simple-select-label" sx={{ color: 'white' }}>Version</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={version}
                    label="Version"
                    onChange={handleChange}
                    sx={{
                        color: 'white',
                        fontSize: '1rem',
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'white',
                        },
                        '& .MuiSvgIcon-root ': {
                            fill: "white",
                        }
                    }}
                >
                    {props.versions.map((it) => (<MenuItem value={it}>{it}</MenuItem>))}
                </Select>
            </FormControl>
        </Box>
    );
}
